export const MESSAGE_LIST_MODES = {
  REGULAR: "regular",
  SELECT: "select",
};

export const MESSAGE_SELECT_TYPE = {
  SELECT: "select",
  MOVE: "move",
};
